<tt-page>
    <tt-card class="filters">
        <tt-tabs [ttSelectedId]="lastSelection" (ttSelectedIdChange)="changeLastSelection($event)">
            <tt-tab ttId="LAST" ttLabel="findcustomers_last"></tt-tab>
            <tt-tab ttId="SEARCH" ttLabel="findcustomers_search"></tt-tab>
        </tt-tabs>
        <tt-tabs [ttSelectedId]="customerType" (ttSelectedIdChange)="changeCustomerType($event)">
            <tt-tab ttId="C" ttLabel="cust_find_customers"></tt-tab>
            <tt-tab ttId="S" ttLabel="cust_find_suppliers"></tt-tab>
            <tt-tab ttId="O" ttLabel="cust_find_other"></tt-tab>
        </tt-tabs>
        <form (ngSubmit)="search()">
            <tt-input ttLabel="customer_search" [(ttModel)]="searchText">
                <ng-container buttons>
                    <!-- A distinct erase action reloads even when the text is already empty. -->
                    <tt-form-field-button ttId="erase" ttIcon="fas fa-eraser" ttType="danger" (ttClick)="clearSearch()"></tt-form-field-button>
                    <tt-form-field-button ttId="search" [ttIcon]="loading ? 'fas fa-spinner fa-spin' : 'fas fa-search'" ttType="success" [ttDisabled]="loading" (ttClick)="search()"></tt-form-field-button>
                </ng-container>
            </tt-input>
        </form>
        <tt-button-goto ttText="customeredit_new" ttGoto="customeredit" [ttGotoParms]="{ cust_no: '0' }" ttTextAlign="left" ttIcon="fas fa-plus" ttIconPullRight></tt-button-goto>
    </tt-card>
    <p *ngIf="error" role="alert">{{ error }}</p>
    <tt-list [ttData]="items" ttBackStyle [ttGoto]="false" [ttButtons]="rowButtons" (ttClick)="select($event.item)"></tt-list>
</tt-page>
